import styles from "./Impressum.module.css";

function Impressum() {
  return (
    <div className={styles.impressumContainer}>
      {/* Hauptüberschrift des Impressums */}
      <h1>Impressum</h1>

      {/* Pflichtangaben nach § 5 TMG */}
      <h2>Angaben gemäß § 5 TMG</h2>
      <div className={styles.infoBox}>
        <h4>Gago's GbR</h4>
        <span>
          Oskar-Meixner-Str. 4<br />
        </span>
        <span>
          68163 Mannheim
          <br />
        </span>
        <span>
          Deutschland
          <br />
        </span>
        <span>
          Telefon: +4915787964401
          <br />
        </span>
        <span>
          E-Mail: kontakt@foodosia.de
          <br />
        </span>
      </div>

      {/* Angaben zum Registereintrag */}
      <div>
        <h3>Registereintrag</h3>
        <br></br>
        <p>Rechtsform: Gesellschaft bürgerlichen Rechts (GbR)</p>
        <p>Registergericht: Amtsgericht Mannheim</p>
      </div>

      {/* Umsatzsteuer-ID nach § 27a UStG */}
      <div>
        <h3>Umsatzsteuer-ID</h3>
        <br></br>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
        </p>
        <p>DE370311094</p>
      </div>

      {/* Gesellschafter der GbR */}
      <div>
        <h3>Gesellschafter</h3>
        <br></br>
        <p>Urania Lagoussi</p>
        <p>Angelos Apokoroniotakis</p>
      </div>

      {/* Verantwortlicher im Sinne von § 55 Abs. 2 RStV */}
      <div>
        <h3>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
        <br></br>
        <p>Urania Lagoussi</p>
        <p>Angelos Apokoroniotakis</p>
        <p>Oskar-Meixner-Str. 4</p>
        <p>68163 Mannheim</p>
      </div>

      {/* Haftungsausschluss mit Unterpunkten */}
      <div>
        <h3>Haftungsausschluss</h3>
        <br></br>
        {/* Haftung für eigene Inhalte */}
        <h4>Haftung für Inhalte</h4>
        <br></br>
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte
          auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
          §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen.
        </p>
        <br></br>
        {/* Haftung für Links auf externe Inhalte */}
        <h4>Haftung für Links</h4>
        <br></br>
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
          fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
          verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
          Seiten verantwortlich.
        </p>
        <br></br>
        {/* Urheberrechtsangaben */}
        <h4>Urheberrecht</h4>
        <br></br>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
          Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
          Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
          Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
          jeweiligen Autors bzw. Erstellers.
        </p>
      </div>

      {/* Hinweis zur Online-Streitbeilegung */}
      <div>
        <h3>Online-Streitbeilegung</h3>
        <br></br>
        <p>
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung (OS) bereit:
        </p>
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#333825" }}
        >
          https://ec.europa.eu/consumers/odr/
        </a>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </div>

      {/* Stand des Impressums */}
      <p style={{ color: "#4B5563" }}>Stand: Juni 2025</p>
    </div>
  );
}

export default Impressum;
